module.exports = "<img src=\"assets/imgs/404.jpg\" alt=\"page not found\" class=\"bg\"/>\r\n\r\n"